import React, { useEffect, useState } from "react";
import Bus from "../../images/logo.png";
import "../../style/appbar.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOut } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import cookies from "js-cookie";
import axios from "axios";
import keycloak from "../../Auth";

export default function Appbar(prop) {
  const [currenttime, setCurrenttime] = useState("");
  const [username, setUsername] = useState("");
  const [rights, setRights] = useState("");

  const Logout = async () => {
    cookies.remove("aathirrantravels", { path: "/" });
    // const realm = sessionStorage.getItem("realm");
    // const id_token = sessionStorage.getItem("id_token");
    sessionStorage.clear();
    // keycloak.logout({ redirectUri: "http://localhost:3000" });
    keycloak.logout();
  };

  const DateTime = () => {
    const date = new Date();
    let y = date.toString();
    let todayDate = y.split(" ")[2];
    let thisMonth = y.split(" ")[1];
    let thisYear = y.split(" ")[3];
    let time = y.split(" ")[4];
    let noon = time.split(":")[0] >= 12 ? "PM" : "AM";
    let space = "  ";

    let final = (
      y.split(" ")[2] +
      "-" +
      y.split(" ")[1] +
      "-" +
      y.split(" ")[3] +
      " " +
      y.split(" ")[4] +
      " " +
      noon
    ).toString();
    setCurrenttime(final);
  };
  setInterval(DateTime, 1000);

  useEffect(() => {
    setUsername(sessionStorage.getItem("username"));
    setRights(sessionStorage.getItem("rights"));
  }, [1]);

  return (
    <div className="AppBar">
      <div className="app-info">
        <img src={Bus} className="logo" alt=""></img>
        <p className="Travel">Aathirran Travels</p>
      </div>
      <div className="user-info">
        <div className="userbox">
          <p className="user">Username - {prop.username}</p>
          <p className="user">{currenttime}</p>
        </div>
        <button className="LogoutBtn" onClick={Logout} title="Logout">
          <Link to={"/"}>
            <FontAwesomeIcon
              className="LogoutIcon"
              icon={faSignOut}
            ></FontAwesomeIcon>
          </Link>
        </button>
      </div>
    </div>
  );
}

//<p className='Logoutlabel'>Logout</p>
